export { useNonF2fMedicalCategories } from './hooks';
export { MedicalCategoryModel, EMedicalCategoryType, type MedicalCategory } from './model/MedicalCategory';
